/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_CalisthenicsInputs */

const en_service_type_calisthenics = /** @type {(inputs: Service_Type_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calisthenics`)
};

const pl_service_type_calisthenics = /** @type {(inputs: Service_Type_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalistenika`)
};

/**
* | output |
* | --- |
* | "Calisthenics" |
*
* @param {Service_Type_CalisthenicsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_calisthenics = /** @type {((inputs?: Service_Type_CalisthenicsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_CalisthenicsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_calisthenics(inputs)
	return en_service_type_calisthenics(inputs)
});